import {INVE_FIELDS} from '@/constants/inve';
import {BankAccount} from '@/types/client-info';
import {getMaskedBankAccount} from '@/utils/client-info/get-masked-bank-account';

export const mapBankAccountsToINVE = (bankAccounts: BankAccount[]) => {
  const mappedBankAccounts: Record<string, string> = {};

  bankAccounts.forEach((account, index) => {
    mappedBankAccounts[`${INVE_FIELDS.INVE34_bankAccountBankNo}#${index}`] = account.bankNo;
    mappedBankAccounts[`${INVE_FIELDS.INVE35_bankAccountTransit}#${index}`] = account.transit;
    mappedBankAccounts[`${INVE_FIELDS.INVE36_bankAccountFolio}#${index}`] = account.folio;
    mappedBankAccounts[`${INVE_FIELDS.INVE37_bankAccountMasked}#${index}`] = getMaskedBankAccount(account);
    mappedBankAccounts[`${INVE_FIELDS.INVE38_bankAccountBankName}#${index}`] = account.bankName || '';
    mappedBankAccounts[`${INVE_FIELDS.INVE39_bankAccountHolder}#${index}`] = account.holder;
  });

  return mappedBankAccounts;
};
